import Vue from 'vue';
import store from '@/store/index';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import ForgotPassword from '../views/Auth/ForgotPassword.vue';
import ResetPassword from '../views/Auth/ResetPassword.vue';
import UserSettings from '../views/Users/UserSettings.vue';
import AppHome from '../views/AppHome.vue';
import UsersLists from '../views/Users/UsersList.vue';
import UsersShow from '../views/Users/UsersShow.vue';
import DivisionsLists from '../views/Divisions/DivisionsList.vue';
import DivisionShow from '../views/Divisions/DivisionShow.vue';

const ProjectRequestList = () =>
  import(
    /* webpackChunkName: "group-forms" */ '../views/ProjectRequests/ProjectRequestList.vue'
  );
const ProjectRequestForm = () =>
  import(
    /* webpackChunkName: "group-forms" */ '../views/ProjectRequests/ProjectRequestForm.vue'
  );
const ProjectRequestResponse = () =>
  import('../views/ProjectRequests/ProjectRequestResponse.vue');
import SimpleRouterView from '@/components/SimpleRouterView.vue';
import PageRedirect from '@/views/PageRedirect.vue';
import NotFound from '@/views/NotFound.vue';
import OrganizationsList from '@/views/Organizations/OrganizationsList.vue';
import ProjectsLists from '@/views/Projects/ProjectsList.vue';
import ProjectShow from '@/views/Projects/ProjectsShow.vue';
import FileShow from '@/views/Files/FileShow.vue';
import VideoShow from '../views/Projects/VideoShow';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/settings',
    name: 'settings',
    component: UserSettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/team',
    component: SimpleRouterView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'team',
        component: UsersLists
      },
      {
        path: 'add',
        name: 'team.create',
        component: UsersShow,
        meta: {
          breadcrumbs: ['team']
        }
      },
      {
        path: ':id',
        name: 'team.view',
        component: UsersShow,
        meta: {
          breadcrumbs: ['team']
        }
      }
    ]
  },
  /*
  {
    path: '/',
    redirect: { name: 'projects' },
    name: 'home',
    component: AppHome,
    children: [
      {
        path: 'users',
        component: SimpleRouterView,
        children: [
          {
            path: '',
            name: 'users',
            component: UsersLists
          },
          {
            path: ':id',
            name: 'users.view',
            component: UsersShow
          }
        ]
      },
      {
        path: 'organization',
        component: SimpleRouterView,
        children: [
          {
            path: '',
            name: 'divisions',
            component: DivisionsLists
          },
          {
            path: ':id',
            name: 'divisions.view',
            component: DivisionShow
          }
        ]
      },
      {
        path: 'projects',
        component: SimpleRouterView,
        children: [
          {
            path: '',
            name: 'projects',
            component: ProjectsLists
          },
          {
            path: ':id',
            name: 'projects.view',
            component: ProjectShow
          },
          {
            path: ':id/videos/:videoId',
            name: 'projects.video',
            component: VideoShow
          }
        ]
      }
    ]
  },
  */
  // {
  //   path: '/organizations',
  //   name: 'organizations',
  //   component: OrganizationsList,
  //   meta: {
  //     title: 'All Organizations'
  //   }
  //   // children: projectRoutes(':organizationID/projects/')
  // },
  // {
  //   path: '/organizations/:organizationID/projects/',
  //   component: ProjectsLists,
  //   name: 'projects.list',
  //   props: true,
  //   meta: {
  //     title: 'All Projects',
  //     breadcrumbs: ['organizations']
  //   }
  // },

  {
    path: '/project-requests',
    component: SimpleRouterView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: ProjectRequestList,
        name: 'projectRequests'
      },
      {
        path: 'create',
        component: ProjectRequestForm,
        name: 'projectRequests.create'
      },
      {
        path: ':id',
        component: ProjectRequestForm,
        props: true,
        name: 'projectRequests.view'
      }
    ]
  },
  {
    path: '/form/:guid',
    component: ProjectRequestResponse,
    name: 'form.response',
    props: true,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // const expireDate = sessionStorage.getItem('expires');
  // const now = Date.now() / 1000;
  const isLoggedIn = !!localStorage.getItem('authToken');
  const requiresAuth =
    to.meta.requiresAuth == undefined || to.meta.requiresAuth;
  if (requiresAuth) {
    // this route requires auth, check if logged in
    if (!isLoggedIn) {
      // if not, redirect to login page.
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      // is logged so we must verify role
      if (to.meta.requiresRole !== undefined) {
        console.warn('router must verify role');
      }
      // requiresRole: ['manager', 'admin']
    }
  }
  // make sure to always call next()!
  next();
});

export default router;
